import React, { useState, useEffect } from "react";
import { Tooltip, Paper, Grid } from '@material-ui/core';
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import UserCreate from "./UserCreate";

const UserMaster = (props) => {
  const [userName, setUserName] = useState('');
  const [userType, setuserType] = useState('');
  const [IsActive, setIsActive] = useState('');
  const [CreatedOn, setCreatedOn] = useState('');
  const [ModifiedOn, setModifiedOn] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [UserID, setUserID] = useState('');
  const [Count, setCount] = useState();
  const [response, fetchData] = UseFetchData();

  const openModal = (row) => {
    setOpen(true);
    setUserID(row.id);
  };

  const handleOpenModal = () => {
    setUserID('');
    setOpen(true);
  };

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("UserID", props.UserID);
    bodyFormData.append("UserName", userName);
    bodyFormData.append("UserType", userType);
    bodyFormData.append("IsActive", IsActive);
    bodyFormData.append("CreatedOn", CreatedOn);
    bodyFormData.append("ModifiedOn", ModifiedOn);
    fetchData("User/List", bodyFormData);
  };

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Edit</a> </strong>),
        // renderCell: (params) => (<strong> <a href="javascript:;"  onClick={() => { openModal(params.getValue("id")); }} >Edit</a> </strong> ), 
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },
      {
        field: "UserName",
        headerName: "User Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "UserType",
        headerName: "User Type",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "IsActive",
        headerName: "Is Active",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "CreatedOn",
        headerName: "Created On",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "ModifiedOn",
        headerName: "Modified On",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 165,
      },

    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);
  }, [response]);

  useEffect(() => {
    PopulateData();
  }, [])

  return (
    <Paper elevation={0} >
      <Grid container direction="row">
        <Grid xs={12} md={3} sm={4} lg={2} xl={2} style={{ marginTop: 10 }} >
          <BiztranControls.Input
            label="User Name"
            //name="UserName"
            //id="UserName"
            onChange={(e) => setUserName(e.target.value)}
          />
        </Grid>
        <Grid xs={12} md={4} sm={4} lg={3} xl={2} style={{ marginTop: 0 }} >
          <div style={{ width: "100%", margin: 10 }} >
            <div style={{ float: "left", marginTop: 0, width: "40%" }}>
              <BiztranControls.Button
                text="SEARCH "
                startIcon={<SearchIcon />}
                onClick={() => {
                  PopulateData();
                }}
              />
            </div>
            <div style={{ float: "left", marginTop: 20, marginLeft: 5, width: "10%" }}>
              <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
            </div>
            <div style={{ float: "left", marginTop: 0, marginLeft: 1, width: "40%" }}>
              <BiztranControls.Button
                text="ADD NEW"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                  handleOpenModal();
                }}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <ModalFrame
        title="User Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <UserCreate
          UserID={UserID}
          setOpen={setOpen}
          PopulateData={PopulateData}
        />
      </ModalFrame>
      <BiztranControls.DataGrid
        rowHeight={25}
        headerHeight={34}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        //Height="530px"
        //Height="700px"
        autoHeight={true}
        Width="70%"
        hideFooter={true}
      />

    </Paper>

  );
};

export default UserMaster;
